module.exports = __webpack_public_path__ + "static/media/button-edit-image.a7cae5ba.svg";